import React, {Component, Fragment} from 'react';
import Nav from '../Nav';
import VideoPlayerComponent from '../Video';
import CompleteTasks from './complete-tasks';
import ConnectingQuestions from './connecting-questions';
import AudioOnly from './audio-only';
import './category-page.scss';
import withAuth from "../../services/withAuth";
import axios from "axios";
import AuthService from "../../services/authService";
import queryString from 'query-string';
import HeartFilled from '../../assets/images/Happily-Ever-After-Icons-Heart-filled.png';
import HeartEmpty from '../../assets/images/Happily-Ever-After-Icons-Heart.png';
import ReactModal from 'react-modal';
import CTour from "../Tour";


class CategoryPage extends Component {
    constructor(props, context) {
        super(props, context);
        // console.log('category page props: ', props)
        this.config = {
            headers: {'Authorization': "bearer " + AuthService.getToken()}
        };
        this.state = {
            category_data: null,
            showModal: false,
            action: null,
            heartState: HeartEmpty,
            url_change: true,
            pageTitle: "",
            showMenu: false,
        }

        // console.log('bring on the category props: ', this.props)
        this.category = this.props.match.params.category;

        this.category_id = this.getCategoryId();

        this.reviewedHeart = false;
        this.watchedHeart = false;
        this.learnedHeart = false;
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount() {
        this.retrieveSingleCategory(this.category_id);

    }

    async retrieveSingleCategory(category_id) {
        let dataURL = `https://onamfc.com/api/category/${category_id}`;
        let actionParams = queryString.parse(this.props.location.search)

        await axios.get(dataURL, this.config).then(response => {
            this.animateHeart();
            this.setState({
                category_data: response.data.shift(),
                showModal: typeof actionParams.a !== 'undefined'
            });
            // this.checkActionParam();

        })

    }

    styleTitle(string) {
        if (string === "Self-Discovery") {
            return string;
        }
        return string.replace(/-/g, " ");
    }


    handleCloseModal() {
        this.setState({showModal: false});
        let video = document.querySelector('.react-player');
        video = video.firstChild;
        // console.log('Video!', video);
        video.play();
    }


    markWatched() {
        // send action Reviewed to API
        let dataURL = "https://onamfc.com/api/progress";
        axios.post(dataURL, {
            progress: {
                "category_id": this.category_id,
                "action": 'watched'
            }
        }, this.config).then(response => {
            //update the user object in local storage
            AuthService.setUser(response.data)

        });
    }

    static eliminateUnderscores(name) {
        return name.split('-').join(' ');
    }

    getCategoryId() {
        switch (this.category.toLowerCase()) {
            case "communication":
                return 1;
            case "conflict-and-repair":
                return 2;
            case "money":
                return 3;
            case "sex-and-intimacy":
                return 4;
            case "family-of-origin":
                return 5;
            case "self-discovery":
                return 6;
        }
    }

    getProgress() {
        return this.props.user.progress.filter(item => item.category_id === this.category_id).shift();
    }

    fillReviewedHeart() {
        this.reviewedHeart = true;
        let reviewedHeart = document.querySelector('.reviewed');
        let image = reviewedHeart.firstChild.firstChild;
        image.className = "heart-new is_animating is_favorite";
        // image.src = HeartFilled;
        // HeartAnimation.animateHeart(reviewedHeart);

    }

    fillLearnedHeart() {
        this.learnedHeart = true;
        let learnedHeart = document.querySelector('.learned');
        let image = learnedHeart.firstChild.firstChild;
        image.className = "heart-new is_animating is_favorite";
        // image.src = HeartFilled;
        // HeartAnimation.animateHeart(learnedHeart);
    }

    fillWatchedHeart() {
        this.watchedHeart = true;
        let watchedHeart = document.querySelector('.watched');
        // HeartAnimation.animateHeart(watchedHeart);
        let image = watchedHeart.firstChild.firstChild;
        image.className = "heart-new is_animating is_favorite";
        // image.src = HeartFilled;
        this.markWatched()
    }

    animateHeart() {
        setTimeout(() => {
            this.setState({heartState: HeartFilled}, this.animateHeart)
        }, 2000)

    }


    handleClick = (e) => {

        // console.log("click triggered", e.target);
        this.setState({
            showMenu: !this.state.showMenu
        })
    }

    handleClose = (e) => {
        let target = e.target;

        if (target.classList.contains('large-text') || target.classList.contains('menu-list') || target.classList.contains('small-text') || target.classList.contains('social-icon') || target.classList.contains('menu-slideout') || target.classList.contains('menu-button')) {
            return;
        }

        // if (target.classList.contains('close-menu')){
        if (this.state.showMenu) {
            this.setState({
                showMenu: false
            })
        }
        // }
        // console.log("close triggered", e.target);
    }

    render() {

        let pageTitle = this.styleTitle(this.props.match.params.category);
        // console.log("props", this.props);
        let url = new URL(document.URL);
        let action = url.searchParams.get("a");

        if (this.state.category_data === null) {
            return (
                <div id="progress-page">
                    <Nav/>
                    <h1>Progress</h1>

                    Loading...

                </div>
            )

        } else if (action === "w") {

            let pdf = this.state.category_data;
            let audio = pdf.audio;
            pdf = pdf.resource;


            return (
                <Fragment>
                    <ReactModal
                        isOpen={this.state.showModal}
                        contentLabel="onRequestClose Example"
                        onRequestClose={this.handleCloseModal}
                        className="Modal"
                        overlayClassName="Overlay"
                        ariaHideApp={false}
                    >
                        <h3>To complete, watch
                            the {CategoryPage.eliminateUnderscores(this.category)} video.</h3>
                        <h3>Once you are finished, the heart will automatically fill in!</h3>
                        <div id="modal-heart_container"><img alt="action-completed" className="heart-icon"
                                                             src={this.state.heartState}/></div>
                        <button onClick={this.handleCloseModal}>Got it! Let's watch</button>

                    </ReactModal>
                    <div id="category-page" onClick={this.handleClose}>
                        <Nav showMenu={this.state.showMenu} handleClick={this.handleClick}
                             handleClose={this.handleClose}/>
                        <div className="page-title-container">
                            <a className="back-btn" href="/progress"><i className="fa fa-arrow-left"></i></a>
                            <h2 className="page-title">{pageTitle}</h2>
                        </div>

                        <div id="video-container">
                            <VideoPlayerComponent
                                handleHeartFill={this.fillWatchedHeart.bind(this)}
                                src={this.state.category_data.hls}
                                tutorial={true}
                            />
                            <div className="button-container">
                                <ConnectingQuestions categoryId={this.category_id}
                                                     fillReviewedHeart={this.fillReviewedHeart.bind(this)} link={pdf}/>
                                <AudioOnly audioLink={audio}/>
                            </div>
                            <CompleteTasks category_id={this.category_id} progress={this.getProgress()}
                                           reviewedHeart={this.reviewedHeart}
                                           watchedHeart={this.watchedHeart}
                                           fillLearnedHeart={this.fillLearnedHeart.bind(this)}/>
                            <div className="button-container">
                                <a className="button ghost-button" href="/progress">View Course Progress</a>
                            </div>

                        </div>
                    </div>
                </Fragment>
            );

        } else if (action === "r") {

            let pdf = this.state.category_data;
            let audio = pdf.audio;
            pdf = pdf.resource;

            return (
                <Fragment>
                    <ReactModal
                        isOpen={this.state.showModal}
                        contentLabel="onRequestClose Example"
                        onRequestClose={this.handleCloseModal}
                        className="Modal"
                        overlayClassName="Overlay"
                        ariaHideApp={false}
                    >
                        <h3>To complete, review
                            the {CategoryPage.eliminateUnderscores(this.category)} connecting questions.</h3>
                        <h3>Once you are finished, the heart will automatically fill in!</h3>
                        <div id="modal-heart_container"><img alt="action-completed" className="heart-icon"

                                                             src={this.state.heartState}/></div>


                        <button onClick={this.handleCloseModal}>Got it! Let's review</button>


                    </ReactModal>
                    <div id="category-page" onClick={this.handleClose}>
                        <Nav showMenu={this.state.showMenu} handleClick={this.handleClick}
                             handleClose={this.handleClose}/>
                        <div className="page-title-container">
                            <a className="back-btn" href="/progress"><i className="fa fa-arrow-left"></i></a>
                            <h2 className="page-title">{pageTitle}</h2>
                        </div>
                        <div id="video-container">
                            <VideoPlayerComponent src={this.state.category_data.hls}
                                                  handleHeartFill={this.fillWatchedHeart.bind(this)}
                                                  tutorial={true}/>
                            <div className="button-container">
                                <ConnectingQuestions categoryId={this.category_id}
                                                     fillReviewedHeart={this.fillReviewedHeart.bind(this)} link={pdf}/>
                                <AudioOnly audioLink={audio}/>
                            </div>
                            <CompleteTasks category_id={this.category_id} progress={this.getProgress()}
                                           reviewedHeart={this.reviewedHeart}
                                           watchedHeart={this.watchedHeart}
                                           fillLearnedHeart={this.fillLearnedHeart.bind(this)}/>
                            <div className="button-container">
                                <a className="button ghost-button" href="/progress">View Course Progress</a>
                            </div>

                        </div>
                    </div>
                </Fragment>
            );

        } else if (action === "l" && this.reviewedHeart === false && this.watchedHeart === false) {

            let pdf = this.state.category_data;
            let audio = pdf.audio;
            pdf = pdf.resource;

            return (
                <Fragment>
                    <ReactModal
                        isOpen={this.state.showModal}
                        contentLabel="onRequestClose Example"
                        onRequestClose={this.handleCloseModal}
                        className="Modal"
                        overlayClassName="Overlay"
                        ariaHideApp={false}
                    >
                        <h3>Please watch the video and review the connecting questions before completing this heart</h3>
                        <div id="modal-heart_container"><img alt="action-completed" className="heart-icon"

                                                             src={this.state.heartState}/></div>
                        <button onClick={this.handleCloseModal}>Got it!</button>


                    </ReactModal>
                    <div id="category-page" onClick={this.handleClose}>
                        <Nav showMenu={this.state.showMenu} handleClick={this.handleClick}
                             handleClose={this.handleClose}/>
                        <div className="page-title-container">
                            <a className="back-btn" href="/progress"><i className="fa fa-arrow-left"></i></a>
                            <h2 className="page-title">{pageTitle}</h2>
                        </div>
                        <div id="video-container">
                            <VideoPlayerComponent src={this.state.category_data.hls}
                                                  handleHeartFill={this.fillWatchedHeart.bind(this)}
                                                  tutorial={true}/>
                            <div className="button-container">
                                <ConnectingQuestions categoryId={this.category_id}
                                                     fillReviewedHeart={this.fillReviewedHeart.bind(this)} link={pdf}/>
                                <AudioOnly audioLink={audio}/>
                            </div>
                            <CompleteTasks category_id={this.category_id} progress={this.getProgress()}
                                           reviewedHeart={this.reviewedHeart}
                                           watchedHeart={this.watchedHeart}
                                           fillLearnedHeart={this.fillLearnedHeart.bind(this)}
                            />
                            <div className="button-container">
                                <a className="button ghost-button" href="/progress">View Course Progress</a>
                            </div>

                        </div>
                    </div>
                </Fragment>
            );
        } else if (action === "l") {
            let pdf = this.state.category_data;
            let audio = pdf.audio;
            pdf = pdf.resource;

            return (
                <Fragment>
                    <ReactModal
                        isOpen={this.state.showModal}
                        contentLabel="onRequestClose Example"
                        onRequestClose={this.handleCloseModal}
                        className="Modal"
                        overlayClassName="Overlay"
                        ariaHideApp={false}
                    >
                        <h3>To complete, click the "I learned something new" heart. </h3>
                        <div id="modal-heart_container"><img alt="action-completed" className="heart-icon"
                                                             src={this.state.heartState}/></div>
                        <button onClick={this.handleCloseModal}>Got it! Let's do it</button>

                    </ReactModal>
                    <div id="category-page" onClick={this.handleClose}>
                        <Nav showMenu={this.state.showMenu} handleClick={this.handleClick}
                             handleClose={this.handleClose}/>
                        <div className="page-title-container">
                            <a className="back-btn" href="/progress"><i className="fa fa-arrow-left"></i></a>
                            <h2 className="page-title">{pageTitle}</h2>
                        </div>
                        <div id="video-container">

                            <VideoPlayerComponent src={this.state.category_data.hls}
                                                  handleHeartFill={this.fillWatchedHeart.bind(this)}
                                                  tutorial={true}
                            />
                            <div className="button-container">
                                <ConnectingQuestions categoryId={this.category_id}
                                                     fillReviewedHeart={this.fillReviewedHeart.bind(this)} link={pdf}/>
                                <AudioOnly audioLink={audio}/>
                            </div>
                            <CompleteTasks category_id={this.category_id} progress={this.getProgress()}
                                           reviewedHeart={this.reviewedHeart}
                                           watchedHeart={this.watchedHeart}
                                           fillLearnedHeart={this.fillLearnedHeart.bind(this)}/>
                            <div className="button-container">
                                <a className="button ghost-button" href="/progress">View Course Progress</a>
                            </div>

                        </div>
                    </div>
                </Fragment>
            );
        } else {
            let pdf = this.state.category_data;
            let audio = pdf.audio;
            pdf = pdf.resource;

            return (
                <Fragment>
                    <CTour/>
                    <ReactModal
                        isOpen={this.state.showModal}
                        contentLabel="onRequestClose Example"
                        onRequestClose={this.handleCloseModal}
                        className="Modal"
                        overlayClassName="Overlay"
                        ariaHideApp={false}
                    >
                        <h3>To complete, click the "I learned something new" heart. </h3>
                        <div id="modal-heart_container"><img alt="action-completed" className="heart-icon"
                                                             src={this.state.heartState}/></div>
                        <button onClick={this.handleCloseModal}>Got it! Let's watch</button>

                    </ReactModal>

                    <div id="category-page" onClick={this.handleClose}>
                        <Nav showMenu={this.state.showMenu} handleClick={this.handleClick}
                             handleClose={this.handleClose}/>
                        <div className="page-title-container">
                            <a className="back-btn" href="/progress"><i className="fa fa-arrow-left"></i></a>
                            <h2 className="page-title">{pageTitle}</h2>
                        </div>
                        <div id="video-container">
                            <div data-tut="reactour__video">
                                <VideoPlayerComponent src={this.state.category_data.hls}
                                                      handleHeartFill={this.fillWatchedHeart.bind(this)}/>
                            </div>
                            <div className="button-container">
                                <ConnectingQuestions categoryId={this.category_id}
                                                     fillReviewedHeart={this.fillReviewedHeart.bind(this)} link={pdf}/>
                                <AudioOnly audioLink={audio}/>
                            </div>
                            <CompleteTasks category_id={this.category_id} progress={this.getProgress()}
                                           reviewedHeart={this.reviewedHeart}
                                           watchedHeart={this.watchedHeart}
                                           fillLearnedHeart={this.fillLearnedHeart.bind(this)}/>
                            <div className="button-container">
                                <a className="button ghost-button" href="/progress">View Course Progress</a>
                            </div>


                        </div>
                        <div className="hiddenDot" data-tut="reactour__blank"></div>
                    </div>
                </Fragment>
            );
        }
    }
}

export default withAuth(CategoryPage);
